module.exports = __webpack_public_path__ + "img/lock.48ed1c66.svg";